module.exports = __webpack_public_path__ + "static/img/edvira.e12bab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/edvira.png
// module id = w+II
// module chunks = 0